export const getFbString = (targetData) => {
    let experimentStringFB = '';
    if (targetData?.fetching === false) {
        const fbExperiments = targetData?.data?.execute?.mboxes;
        if (fbExperiments) {
            fbExperiments.forEach((experiment) => {
                const activityName = experiment?.options?.[0]?.responseTokens?.['activity.name'];
                const experinceName = experiment?.options?.[0]?.responseTokens?.['experience.name'];
                if (activityName && experinceName) {
                    const newExperimentString = `${activityName} ${experinceName}, `;
                    if (!experimentStringFB.includes(newExperimentString)) experimentStringFB += newExperimentString;
                }
            });
            experimentStringFB = experimentStringFB.replace(/,\s*$/, '');
        }
    }
    return experimentStringFB;
};

export const getVcString = (targetData) => {
    let experimentStringVC = '';
    if (targetData?.fetching === false) {
        const vcExperiments = targetData?.data?.execute?.pageLoad?.options;
        if (vcExperiments) {
            targetData?.data?.execute?.pageLoad?.options.forEach((experiment) => {
                const activityName = experiment?.responseTokens?.['activity.name'];
                const experinceName = experiment?.responseTokens?.['experience.name'];
                if (activityName && experinceName) {
                    const newExperimentString = `${activityName} ${experinceName}, `;
                    if (!experimentStringVC.includes(newExperimentString)) experimentStringVC += newExperimentString;
                }
            });
            experimentStringVC = experimentStringVC.replace(/,\s*$/, '');
        }
    }
    return experimentStringVC;
};

export const getFullExperimentString = (targetData) => {
    const fbString = getFbString(targetData);
    const vcString = getVcString(targetData);
    const AdobeExperiment = (fbString + ' ' + vcString).trim();

    return AdobeExperiment === '' ? undefined : AdobeExperiment;
};
